module.exports = __webpack_public_path__ + "static/media/icon_sora3a8272932d58d7aee5d9790c1599a9af.webp";